import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLazyGetApplicationTenantConfigurationDetailsQuery } from '../../api/app/DashBoardApiService'
import { setAppConfig } from '../../redux/reducers/AtlasSandReducer'

const useApplicationConfigQuery = () => {
  const dispatch = useDispatch()
  const [getApplicationConfig, { data, error, isFetching }] =
    useLazyGetApplicationTenantConfigurationDetailsQuery()

  useEffect(() => {
    if (!isFetching && data) {
      dispatch(setAppConfig(data))
    }
    if (error) {
      console.error(error)
    }
  }, [data, isFetching, dispatch, error])
  return { getApplicationConfig }
}
export default useApplicationConfigQuery
